// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"82583607","455":"c4ca956a"}[chunkId] + ".chunk.js";
};